module.exports = __webpack_public_path__ + "static/media/EBZ Logo.96ff2492.png";